import * as rdd from "react-device-detect";

const AuthSession = {
  isTokenValid: () => {
    try {
      const storedData = localStorage.getItem("userData");
      if (!storedData) return false;

      const dataStore = JSON.parse(storedData);
      if (!dataStore?.expires_in || !dataStore?.time) return false;

      let dateTime = Math.floor(Date.now() / 1000);
      let expDate = parseInt(dataStore.expires_in) + parseInt(dataStore.time);

      return !isNaN(expDate) && dateTime < expDate;
    } catch (error) {
      console.error("Error parsing userData:", error);
      return false;
    }
  },

  getDeviceInfo: () => ({
    device_name: rdd.osName || "Unknown",
    device_serial: rdd.osVersion || "Unknown",
    app_version_name: rdd.browserName || "Unknown",
    app_version_code: "2",
    device_imei: "N/A", // Removed hardcoded value
    device_type: rdd.isMobile ? "mobile" : "desktop",
  }),

  saveSession: (response) => {
    try {
      const user = response.data.user || response.data.investor;
      if (!user) return;

      localStorage.setItem("userData", JSON.stringify(user));
      localStorage.setItem("tokenDataAuth", user.token || "");
      localStorage.setItem("userRole", user.role || "");
      localStorage.setItem("userId", user.id || "");
      localStorage.setItem("userIsLoggedIn", "true");
    } catch (error) {
      console.error("Error saving session:", error);
    }
  },

  getToken: () => localStorage.getItem("tokenDataAuth"),

  saveToken: (token) => {
    if (token) localStorage.setItem("tokenDataAuth", token);
  },

  getClientId: () => localStorage.getItem("userId"),

  getClientRole: () => {
    try {
      return localStorage.getItem("userRole");
    } catch (error) {
      console.error("Error parsing userRole:", error);
      return null;
    }
  },

  saveUser: (response) => {
    try {
      const userId =
        response.data.user?.id || response.data.investor?.investorId;
      if (userId) localStorage.setItem("userId", userId);
    } catch (error) {
      console.error("Error saving user:", error);
    }
  },

  isLoggedIn: () => localStorage.getItem("userIsLoggedIn") === "true",

  getCountry: () => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      return userData?.country || null;
    } catch (error) {
      console.error("Error parsing userData:", error);
      return null;
    }
  },

  logOut: () => {
    localStorage.clear();
  },

  isCorporate: () => {
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      return userData?.role === "investor";
    } catch (error) {
      console.error("Error parsing userData:", error);
      return false;
    }
  },
};

export default AuthSession;
